<template>
  <div class="modal-container">
    <LsClickable
      track-id="return_request_modal-close"
      class="modal-close-x"
      @click="attemptClose"
      @mouseover="closeColor = 'gray-secondary'"
      @mouseleave="closeColor = 'primary'"
    >
      <LsIcon type="close" :color="closeColor" />
    </LsClickable>
    <div v-if="confirmClose">
      <header class="modal-header">Are you sure you want to exit?</header>
      <section class="modal-body"><p>You are exiting reporting an issue</p></section>
      <footer class="modal-footer">
        <LsButton
          text="return"
          bg-color="primary"
          track-id="return_request_modal-return"
          @click="confirmClose = false"
        />
        <LsButton text="yes, exit" track-id="return_request_modal-confirm" @click="close" />
      </footer>
    </div>
    <Component :is="component" v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import {
  ReturnRequestCreditApplied,
  ReturnRequestCreditOrFix,
  ReturnRequestRedistribute,
  ReturnRequestFixRequested,
  ReturnRequestLocation,
  ReturnRequestNotes,
  ReturnRequestPhotos,
  ReturnRequestPartialCompleteReminder,
  ReturnRequestQualityIssue,
  ReturnRequestSecondReview,
  ReturnRequestSuccess,
  ReturnRequestConfirmFix,
} from '.';
import { LsButton, LsClickable, LsIcon } from '@/components/common';

export default {
  name: 'ReturnRequestModal',
  components: {
    LsButton,
    LsClickable,
    LsIcon,
    ReturnRequestCreditApplied,
    ReturnRequestCreditOrFix,
    ReturnRequestRedistribute,
    ReturnRequestFixRequested,
    ReturnRequestLocation,
    ReturnRequestNotes,
    ReturnRequestPhotos,
    ReturnRequestPartialCompleteReminder,
    ReturnRequestQualityIssue,
    ReturnRequestSecondReview,
    ReturnRequestSuccess,
    ReturnRequestConfirmFix,
  },
  data() {
    return {
      confirmClose: false,
      closeColor: 'primary',
    };
  },
  computed: {
    ...mapState(['dispute']),
    component() {
      return _.get(this.$options.components, this.dispute.currentDispute.currentStep);
    },
  },
  methods: {
    close() {
      this.$router.replace({ name: 'services' });
      this.$parent.close();
    },
    attemptClose() {
      const { currentStep } = this.dispute.currentDispute;
      if (
        _.includes(
          ['ReturnRequestCreditApplied', 'ReturnRequestFixRequested', 'ReturnRequestSuccess'],
          currentStep
        )
      ) {
        this.close();
      } else {
        this.confirmClose = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-footer {
  button:first-of-type {
    margin-right: 5px;
  }

  button:last-of-type {
    margin-left: 5px;
  }
}
</style>
